/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MergeSources200ResponseData } from './MergeSources200ResponseData';
import {
    MergeSources200ResponseDataFromJSON,
    MergeSources200ResponseDataFromJSONTyped,
    MergeSources200ResponseDataToJSON,
} from './MergeSources200ResponseData';

/**
 * 
 * @export
 * @interface MergeSources200Response
 */
export interface MergeSources200Response {
    /**
     * 
     * @type {MergeSources200ResponseData}
     * @memberof MergeSources200Response
     */
    data: MergeSources200ResponseData;
}

/**
 * Check if a given object implements the MergeSources200Response interface.
 */
export function instanceOfMergeSources200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function MergeSources200ResponseFromJSON(json: any): MergeSources200Response {
    return MergeSources200ResponseFromJSONTyped(json, false);
}

export function MergeSources200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeSources200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': MergeSources200ResponseDataFromJSON(json['data']),
    };
}

export function MergeSources200ResponseToJSON(value?: MergeSources200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': MergeSources200ResponseDataToJSON(value.data),
    };
}

